/* eslint-disable no-unused-expressions */

/******************************************************************************
 * Sys Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

// import { config, key } from 'localforage';
import React from 'react';
import DateFormat  from './DateFormat';
import { ObjectUtil } from './ObjectUtil';
import './SystemUtils.scss';
// import { createPortal } from 'react-dom';

const exec = window.require?.('child_process').exec;
const os = window.require?.('os'); 

let urlVars;

const secondsToTime = c => {
	let h = Math.floor( c / 3600);
	let m = Math.floor((c - (h * 3600)) / 60);
	let s = Math.floor(c - (h * 3600) - (m * 60));
	return h + ':' + (m < 10? '0'+m : m) + ':' + (s < 10? '0'+s : s);
}

//============================================================================= Sys Class
export default class Sys {
	static loadImages = async (images, onLoad) => {
		if (typeof images === 'object'){
			images = Object.entries(images).map(([name, src]) => {
				return {name, src}
			});
		}

		return new Promise(resolve => {
			Promise.all(images.map((src, i) => {
				return this.loadImage(src, onLoad, i);
			})).then((loadedImages) => {
				let r={};
				loadedImages.forEach((curImage) => {
					r[curImage.name] = curImage;
				})
				resolve(r);
			});
		})
	}


	static loadImage = async (src, onLoad, i=0) => {
		return new Promise((resolve, reject)=>{
			if(typeof src === 'string') src = {	name:'image'+i, src };
			let img = new Image();
			src.img = img;
			img.onload = () => {
				onLoad?.(src);
				resolve(src);
			}
			img.onerror = img.onabort = reject;
			img.src = src.src;
		})
	}

	// static loadImage = async (image) => {
	// 	if (Array.isArray(image)){
	// 		return Promise.all(image.map((src,i)=>{
	// 			return this.loadImage(src);
	// 		}));
	// 	}

	// 	if (typeof image === 'object' && !image.src){
	// 		return Promise.all(
	// 			Object.keys(image).map(i => {
	// 				return this.loadImage(image[i]);
	// 			}
	// 		))
	// 	}

	// 	console.log(image.src);

	// 	new Promise((resolve, reject) => {
	// 		let img = new Image();
	// 		image.img = img;
	// 		img.onload = e => resolve(image);
	// 		img.onerror = img.onabort = e => reject(e);
	// 		img.src = image.src;
	// 	});
	// }

	
	static wait = async (sec=3) => {
		await new Promise(r => setTimeout(r, sec * 1000));	//wait n sec
	}
	

	static getDateTime(date, format='dd.mm.yyyy HH:MM:ss'){
		let now = date || new Date();
		let d = DateFormat(now, format);
		return d;
	}


	static getPlayTime(){
		return secondsToTime(performance.now() / 1000);
	}


	// ------------------------------------------------------------------------ get node type
	// none | array | boolean | number | string | date | object
	static getType(value){
		if (value === undefined || value === null) return 'none';
		let t = typeof value;
		if (t === 'object') return Array.isArray(value)? 'array' : t;
		if (value === 'true' || value === 'false') return 'boolean';
		return t;
	}


	// ------------------------------------------------------------------------ fullScreenshot
	// https://hackernoon.com/how-to-take-screenshots-in-the-browser-using-javascript-l92k3xq7
	//
	static async getScreenshot(callback, imageFormat='image/jpeg') {
		console.log('capture webrtc-screen');

		let stream;

		try {
			const desktopCapturer = window.require?.('electron').desktopCapturer;
			// const win = window.require?.('electron').remote?.getCurrentWindow();
			const win = window.require?.('@electron/remote').getCurrentWindow();

			if (desktopCapturer && win){	//electron native screen capture
				let title = win.getTitle();
				let size = win.getSize();
				let sources = await desktopCapturer.getSources({ types: ['window', 'screen'] });
				let source = sources.find(s => s.name === title);	//find the application window
				if (!source){
					console.error('no media source found:', title, sources)
					return null
				}
				
				console.log('native window-capture:', title, size[0], size[1], source);

				stream = await navigator.mediaDevices.getUserMedia({
					audio: false,
					video: {
						mandatory: {
							chromeMediaSource: 'desktop',
							chromeMediaSourceId: source.id,
							minWidth: size[0],
							maxWidth: size[0],
							minHeight: size[1],
							maxHeight: size[1]
						}
					}
				});
		
			}else{		//	browser-window screen capture
				console.log('browser window-capture:', window.innerWidth, window.innerHeight);
				stream = await navigator.mediaDevices.getUserMedia({video:true});

			}

			const video = document.createElement("video");
			video.srcObject = stream;
			await new Promise(e => video.onloadedmetadata = e);

			console.log('video-data:', video.videoWidth, video.videoHeight);
			await video.play();

			const canvas = document.createElement("canvas");
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			const context = canvas.getContext("2d");
			context.drawImage(video, 0, 0);
			const frame = canvas.toDataURL(imageFormat, 0.9);
			// window.location.href = frame;

			video.remove();							// Remove hidden video tag
			try {
				stream.getTracks()[0].stop();		// Destroy connect to stream
			} catch (e) {}
		
			callback?.(frame);
			return frame;

		} catch (err) {
			console.error("Error: " + err);
			callback?.(null);
		}
	}


	//----------------------------------------------------------------------------- loadConfig
	static async loadConfig(url, options){
		url = url || './config.json';

		let config = await this.fetch(url);
		if (!config){
			if (typeof options === 'function') options(null);		//callback function
			return null;
		}

		return this.parseConfig(config, options);
	}


	//----------------------------------------------------------------------------- parseConfig
	static parseConfig(config, options = {}){
		try {
			if (config.environment && config.environment[process?.env.NODE_ENV]){
				ObjectUtil.append(config, config.environment[process?.env.NODE_ENV]);
			}
		} catch (error) {
			console.error('not a node environment!');
		}

		config = ObjectUtil.replaceNodes(config); // replace all placeholders from json data

		if (config.device){
			const dev = this.getDevice();
			if (config.device[dev]){
				ObjectUtil.append(config, config.device[dev]);
			}
		}

		// ---merge runtime attributes
		if (config.runtime){
			const runtime = window.require ? 'node' : 'web';
			if (config.runtime[runtime]){
				ObjectUtil.append(config, config.runtime[runtime]);
			}
		}

		// ---merge optional settings
		if (options?.merge){
			Object.keys(options.merge).forEach(key => {
				if (config[key] && config[key][options.merge[key]]){
					ObjectUtil.append(config, config[key][options.merge[key]]);
				}
			});
		}

		console.log('config (parsed):', config);
		global.config = config;

		if (typeof options === 'function') options(config); // callback function
		return config;
	}


	//----------------------------------------------------------------------------- getSysinfo
	static async getSysinfo(){
		return {
			username: os?.userInfo?.().username || await Sys.cmd('username'),
			computername: os?.hostname?.() || await Sys.cmd('computername'),
			serialnumber: await Sys.cmd('serialnumber'),
			teamviewer: await Sys.cmd('teamviewer')
			// os: Sys.getOS(),
			// platform: Sys.getPlatform(),
			// arch: Sys.getArch(),
			// locale: Sys.getLocale(),
			// hostname: Sys.getHostname(),
			// uptime: Sys.getUptime(),
			// memory: Sys.getMemory(),
			// cpu: Sys.getCpu(),
			// gpu: Sys.getGpu(),
			// network: Sys.getNetwork(),
			// disk: Sys.getDisk(),
			// screen: Sys.getScreen(),
			// battery: Sys.getBattery(),
		}
	}


	//----------------------------------------------------------------------------- cmd
	//https://nodejs.org/api/child_process.html#child_process_child_process_exec_command_options_callback
	// Computer\HKEY_LOCAL_MACHINE\SOFTWARE\WOW6432Node\TeamViewer
	// cmd('file', callback, {cmd:'folder'})
	static async cmd(command, callback, opt){
		if (!exec) return null;			//not a node environment!

		let c;

		switch (command){
		case 'teamviewer': c = 'reg query HKLM\\SOFTWARE\\WOW6432Node\\TeamViewer /v ClientID || reg query HKLM\\SOFTWARE\\TeamViewer /v ClientID';
			break;
		// case 'teamviewer': c = 'reg query HKLM\\SOFTWARE\\WOW6432Node\\TeamViewer /v ClientID'; break;
		// case 'teamviewer_2': c = 'reg query HKLM\\SOFTWARE\\TeamViewer /v ClientID'; break;
		case 'serialnumber': c = 'wmic bios get serialnumber'; break;
		case 'computername': c = 'hostname'; break;
		case 'username': c = 'echo %username%'; break;
		default: c = command;
		}

		return new Promise((resolve, reject) => {
			try {
				exec(c, opt, (error, stdout, stderr) => {
					if (!stdout){
						callback?.(null);
						// console.error(error);
						return resolve('');	//error
					}
		
					let result = stdout.replace(/\r?\n|\r/g, '');
					let a;
					switch (command){
					case 'teamviewer':
					case 'teamviewer_2':
						a = result.split(' ');
						result = parseInt(a[a.length-1]);
						result = result? String(result) : ''
						break;
					case 'serialnumber':
						a = result.split('      ');
						result = a[a.length-1].trim();
						break;
					// case 'computername': return result;
					default:
					}
	
					callback?.(result);
					return resolve(result);
				})
			} catch (error) {
				console.error('error on running script', c);
				console.error(error);
				callback?.(null);
				return resolve('');
			}
		})
	}

	
	//----------------------------------------------------------------------------- getRuntime
	static isMobile(device){	//https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
		let nu = navigator.userAgent;
		switch(device){
			case 'android'		: return nu.match(/Android/i);
			case 'blackberry'	: return nu.match(/BlackBerry/i);
			case 'ios'			: return nu.match(/iPhone|iPad|iPod/i);
			case 'opera'		: return nu.match(/Opera Mini/i);
			case 'windows'		: return nu.match(/IEMobile/i);
			case undefined:
			case 'any'			: return (
				this.isMobile('android') ||
				this.isMobile('blackberry') ||
				this.isMobile('ios') ||
				this.isMobile('opera') ||
				this.isMobile('windows')) || false;
			default:
		}
	}
	
	
	//----------------------------------------------------------------------------- getRuntime
	static isOS(os){
		switch(os){
			case 'windows'		: return navigator.userAgent.match(/Windows/i);
			case 'linux'		: return navigator.userAgent.match(/Linux/i);
			// case 'ios'			: return;
		default:
		}
	}


	//----------------------------------------------------------------------------- logSystem
	static logSystem = () => {
		const log = (...val) => {	//colorized log output
			console.log('%c' + val.join(' '), 'color:#8b0');
		}

		let sys = this.getSystem()

		log('=================================================');
		log('agent            :', sys.agent);
		log('location         :', sys.location);
		// log('dirname          :', __dirname);
		// log('filename         :', __filename);
		log('environment      :', sys.environment);
		log('os               :', sys.os);
		if (os?.version){
			// log('release          :', sys.release);
			// log('platform         :', sys.platform);
			log('computername     :', sys.computername);
			log('username         :', sys.username);
		}
		log('browser          :', sys.browser);
		log('device           :', sys.device);
		log('runtime          :', sys.runtime);

		if (window.process){
			log('node version     :', sys.version.node);
			log('chrome version   :', sys.version.chrome);
			log('electron version :', sys.version.electron);
		}
		
		log('react version    :', sys.version.react);
		log('=================================================');

		global.system = sys;
		global.isDev = sys.environment === 'development'	//short-key für development mode

		console.log('location:', window.location.href, window.location, )
		console.log('navigator:', window.navigator)
	
		return sys;
	}


	//----------------------------------------------------------------------------- getSystem
	static getSystem = () => {
		let sys = {}
		sys.agent		= navigator.userAgent
		sys.location	= window.location.href
		sys.environment	= process.env.NODE_ENV		//development | production

		if (os){
			sys.os = os.version?.() || this.getOs()

			//hotfix for windows 11 version
			if (sys.os.startsWith('Windows') && sys.release){
				let ver = Number(sys.release.split('.').pop())
				if (ver >= 22000) sys.os = sys.os.replace('10', '11')
			}

			// sys.release = os.release?.()
			// sys.platform = os.platform?.() + ' ' + os.arch?.()
			sys.os += ', ' + os.release?.() + ', ' + os.platform?.() + ' ' + os.arch?.()

			sys.computername = os.hostname?.()
			sys.username = os.userInfo?.().username
		}else{
			sys.os = this.getOs()
		}
		
		sys.browser		= this.getBrowser()
		sys.device		= this.getDevice()
		sys.runtime		= this.getRuntime()
		sys.version	= {
			react		: React.version,
		}

		if (window.process){
			let v = window.process.versions;
			sys.version.node = v.node;
			sys.version.chrome = v.chrome;
			sys.version.electron = v.electron;
		}

		return sys
	}


	//----------------------------------------------------------------------------- getRuntime
	static getRuntime = () => {
		// not working anymore!!!
		// return (typeof process !== 'undefined') && (process?.release?.name === 'node')? 'node' : 'web';
		return window.require? 'node' : 'web';
	}


	//----------------------------------------------------------------------------- getOs
	static getOs = () => {
		let ua = window.navigator.userAgent
		if (ua.indexOf("Win") !== -1) return "Windows";
		if (ua.indexOf("Mac") !== -1) return "MacOS";
		if (ua.indexOf("X11") !== -1) return "UNIX";
		if (ua.indexOf("Linux") !== -1) return "Linux";
		return 'unknown'
	}


	//----------------------------------------------------------------------------- getBrowser
	static getBrowser = () => {		//https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
		let sBrowser, sUsrAg = navigator.userAgent;
		// The order matters here, and this may report false positives for unlisted browsers.
		if (sUsrAg.indexOf("Firefox") > -1) {
			sBrowser = "Mozilla Firefox";
		// "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
		} else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
			sBrowser = "Samsung Internet";
		// "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
		} else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
			sBrowser = "Opera";
		// "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
		} else if (sUsrAg.indexOf("Trident") > -1) {
			sBrowser = "Microsoft Internet Explorer";
		// "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
		} else if (sUsrAg.indexOf("Edge") > -1) {
			sBrowser = "Microsoft Edge";
		// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
		} else if (sUsrAg.indexOf("Chrome") > -1) {
			sBrowser = "Google Chrome or Chromium";
		// "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
		} else if (sUsrAg.indexOf("Safari") > -1) {
			sBrowser = "Apple Safari";
		// "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
		} else {
			sBrowser = "unknown";
		}

		// console.log('browser:', sBrowser);
		return sBrowser;
	}


	//----------------------------------------------------------------------------- getDevice
	static getDevice = () => {		//https://dev.to/itsabdessalam/detect-current-device-type-with-javascript-490j
		const ua = navigator.userAgent;
		if (ua.includes('Electron')) {
			return "desktop";
		}
		// if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {	//macintosh can also be a mac
		if (/(tablet|ipad|macintosh|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
			return "tablet";		//macbook is like a tablet
		}
		if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
			return "mobile";
		}
		return "browser";
	}


	//----------------------------------------------------------------------------- download
	// html-download to local file
	static download = (name, data) => {
		let a = document.createElement('a');
		let file = new Blob([JSON.stringify(data)]);
		a.href = URL.createObjectURL(file);
		a.download = name;
		a.click();
	}

	
	//----------------------------------------------------------------------------- getTimeString
	static getTimeString = (date) => {
		date = date || new Date();
		return date.toLocaleDateString('fr-CA') + ' ' + date.toLocaleTimeString();		//e.g.: 2020-11-15 10:23:45
	}


	//----------------------------------------------------------------------------- log
	// e.g: await sleep(1000);		//wait 1 sec.
	static sleep = (ms = 0) => {
		return new Promise(r => setTimeout(r, ms));
	}


	//----------------------------------------------------------------------------- log
	static logMessage = '';
	static logElement;

	static log = message => {
		let el = this.logElement;
		if (!message){
			if (el) el.remove();
			return this.logElement = null;
		}

		if (!el){
			let root = document.getElementById('root');
			el = document.createElement('div');
			el.setAttribute('class', 'sys-modal sys-log');
			el.onclick = e => this.log();
			root.appendChild(el);
			this.logElement = el;
		}

		el.innerHTML = '<div class="sys-log-text">' + message + '</div>';
		// el.innerHTML = message;
	}


	//----------------------------------------------------------------------------- info
	// pos: top | bottom
	static sysInfo
	static infoMessage

	static info = (message, clear=false, pos='bottom') => {
		let el = this.sysInfo
		const root = document.getElementById('root');

		if (!message){
			el?.remove()
			return this.sysInfo = null
		}

		if (!el){
			this.sysInfo = el = document.createElement('div');
			el.setAttribute('class', `sys-info ${pos}`);
			root.appendChild(el);
		}

		let msg = '';
		if (typeof message === 'string'){
			msg = message;
			
		}else if (typeof message === 'object'){
			if (clear) this.infoMessage = null

			if (!this.infoMessage){
				this.infoMessage = message
			}else{
				this.infoMessage = {...this.infoMessage, ...message}
			}

			for (let e in this.infoMessage){
				msg += `<div class="sys-info-item"><div>${e}:</div><div>${this.infoMessage[e]}</div></div>`
			}
		}

		el.innerHTML = msg;
	}

	//----------------------------------------------------------------------------- status
	static status = (message) => {
		this.info(message, 'bottom')
	}


	//----------------------------------------------------------------------------- alert
	// sample:
	// Sys.alert('Your Message', false, ['Abbrechen', 'OK'], {onSelect:e => {
	// 	console.log('select', e)
	// }})
	//
	static alertElement;
	static alertTimeout;

	static alert = (message, spinner=false, button='OK', props) => {
		let autoClose = props?.autoClose ?? true
		let el = this.alertElement;
		if (!!this.alertTimeout) clearTimeout(this.alertTimeout);

		if (!message && !spinner){
			if (el) el.remove();
			return this.alertElement = null;
		}

		if (!el){
			let root = document.getElementById('root');
			el = document.createElement('div');
			el.className = 'sys-modal sys-alert';
			root.appendChild(el);
			this.alertElement = el;
		}else{
			while (el.lastElementChild) el.removeChild(el.lastElementChild);
		}

		let m = document.createElement('div');
		m.className = 'sys-alert-text';
		m.innerHTML = message;
		el.appendChild(m);

		console.info('[' + message + ']')

		if (spinner){
			let s = document.createElement('div');
			s.innerHTML = `<svg class='sys-spinner' >
				<circle cx='20' cy='20' r='16' stroke='white' opacity='0.10' />
			 	<circle cx='20' cy='20' r='16' stroke='white' opacity='0.5' />
			</svg>`
			el.appendChild(s);
		}

		if (Array.isArray(button)){
			let btn = document.createElement('div');
			btn.className = 'sys-buttons';
			el.appendChild(btn);

			button.forEach(e => {
				let b = document.createElement('div');
				b.className = 'sys-button';
				b.innerHTML = e;
				b.addEventListener('click', () => {
					props?.onSelect?.(e)
					if (autoClose) Sys.alert()
				})
				btn.appendChild(b);
			})
		}else if (button){
			let b = document.createElement('div');
			b.className = 'sys-button';
			b.innerHTML = button;
			b.addEventListener('click', e => {
				props?.onSelect?.(e)
				if (autoClose) Sys.alert()
			})
			el.appendChild(b);
		}

		if (props && props.onTimeout){
			this.alertTimeout = setTimeout(props.onTimeout, props.timeout || 5000);
		}
		return el;
	}


	//----------------------------------------------------------------------------- getUrlVars
	static getUrlVars = function(){
		if (urlVars) return urlVars;

		urlVars = {};
		// window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {urlVars[key] = value});
		window.location.search.substring(1).split('&').forEach(param => {
			const [key, value] = param.split('=').map(decodeURIComponent);
			if (key) urlVars[key] = value;
		});
	
		return urlVars;
	}


	//----------------------------------------------------------------------------- getHtml
	static async getHtml(url, callback, search){
		let html = await ( await fetch(url) ).text();
		let doc = new DOMParser().parseFromString(html, 'text/html');

		if (search){
			let type = search.substring(0, 1);
			let list;
			if (type === '.') list = doc.getElementsByClassName(search.substring(1));
			else if (type === '#') list = doc.getElementById(search.substring(1));
			else list = doc.getElementsByTagName(search);
			return (Array.from(list));
		}else{
			if (callback) callback(doc);
			return doc;
		}
	}


	//----------------------------------------------------------------------------- fetch
	// from: https://developer.mozilla.org/en-US/docs/Web/API/Streams_API/Using_readable_streams
	//
	// const controller = new AbortController()
	// button.addEventListener("click", () => signal.abort());
	//
	// const response = await fetch(url, { signal: controller.signal });
	//
	// const reader = response.body.getReader();
	// return new ReadableStream({
	// 	start(controller) {
	// 		return pump();
	// 		function pump() {
	// 			return reader.read().then(({ done, value }) => {
	// 			// When no more data needs to be consumed, close the stream
	// 			if (done) {
	// 				controller.close();
	// 				return;
	// 			}
	// 			// Enqueue the next data chunk into our target stream
	// 			controller.enqueue(value);
	// 			console.log('pump', value)
	// 			return pump();
	// 			});
	// 		}
	// 	},
	// })
	//
	static async stream(url, onChunk){

		const binArrayToJson = binArray => {
			let str = "";
			for (let i = 0; i < binArray.length; i++) {
				str += String.fromCharCode(parseInt(binArray[i]));
			}
			// console.log(str);
			// return JSON.parse(str)
			return str;
		}
	
		let response = await fetch(url)
		let result = '';
		let loaded = 0;

		// polyfill for asyncIterator
		// https://stackoverflow.com/questions/56991610/read-a-stream-with-for-await-using-javascript-in-the-browser
		if (!response.body[Symbol.asyncIterator]) {
			response.body[Symbol.asyncIterator] = () => {
				const reader = response.body.getReader();
				return {
					next: () => reader.read(),
					return: () => reader.releaseLock(),
				}
			}
		}

		const total = Number(response.headers.get('content-length'));	//only if onlune url
		// console.log('content-length:', total)
		let n = 0
		
		for await (const chunk of response.body) {
			loaded += chunk.length;
			let str = binArrayToJson(chunk)
			result += str
			onChunk?.(str)
			// if (n++ < 10) console.log('loaded:', loaded, str)
		}				
		return result
	}


	//----------------------------------------------------------------------------- fetch
	// check: https://dmitripavlutin.com/timeout-fetch-request/?utm_source=pocket_mylist
	// e.g: Sys.fetch(url, {method:'PUT', body:JSON.stringify(data)})
	// TODO: optional load first from localStore
	//
	/*
	let data = await (await (fetch('C:/JTClient/sysinfo.cfg')
			.then(res => {return res.json()})
			.catch(err => {
				console.log('error on loading: C:/JTClient/sysinfo.cfg');
			})
		))
	*/
	static async fetch(url, options={}, callback, store='', onlineFirst=true){
		//---fetch used with timeout handler
		const timeout = options?.timeout || 15000	//default = 15 sec. timeout
		const controller = new AbortController()
		const timeoutId = setTimeout(() => controller.abort(), timeout);

		if (options){
			store = options.store || store
			callback = options.callback || callback
			onlineFirst = options.onlineFirst || onlineFirst
			options.signal = controller.signal   
		}

if (typeof callback === 'object' && options === null) options = callback	//workaround for old version

		if (store === true) store = url;	//take url as store-key

		if (store && !onlineFirst){			//try to take local store data first
			let data = localStorage.getItem(store);
			if (data){
				console.log('data from localStore:', store);
				if (callback && typeof callback === 'function')	callback(data);
				return data;
			}
		}

		let res = await fetch(url, options).catch(err => {
			console.error('fetch error!', err);
		});

		clearTimeout(timeoutId);	//clear timeoutId

		let data;

		if (res?.ok){
			// res.headers.forEach((value, name) => console.log('> ' + name + ' : ' + value))

			let type = res.headers.get('content-type');
			if (type.includes('application/json')){
				data = await res.json().catch(err => {
					console.error('json error!', url, err);
					return null
				})
			}else{
				data = await res.text().catch(err => {
					console.error('json error!', url, err);
					return null
				})
			}
		}else{
			console.log('error on loading data!', url)
		}

		if (store){
			if (data){	//update new loaded data to localStore
				console.log('save to localStore:', store);
				try {
					localStorage.setItem(store, data);
				} catch (error) {
					console.error('error on setting item to localStore!', store, error);
				}
			}else{		//fallback: load data from localStore
				data = localStorage.getItem(store);
				if (data){
					console.log('data from localStore:', store);
					// data = JSON.parse(data);
				}
			}
		}

		if (callback && typeof callback === 'function')	callback(data);
		return data;
	}


	//----------------------------------------------------------------------------- setFullscreen
	static setFullscreen = async (on, elem=document.documentElement) => {
		const isOn = document.fullscreenElement !== null;
		const noChange = (on === undefined || on === isOn);
		if (noChange) return;

		try {
			if (isOn) {
				await (
					document.exitFullscreen ||
					document.mozCancelFullScreen ||
					document.webkitExitFullscreen ||
					document.msExitFullscreen
				).call(document);
				this.isFullscreen = false;
			} else {
				await (
					elem.requestFullscreen ||
					elem.mozRequestFullScreen ||
					elem.webkitRequestFullscreen ||
					elem.msRequestFullscreen
				).call(elem);
				this.isFullscreen = true;
			}
		} catch (error) {
			console.error('fullscreen error!', error);
		}
	}


	//----------------------------------------------------------------------------- fullscreen
	static isFullscreen = false;

	static switchFullscreen = async (elem=document.documentElement) => {
		// let elem = document.documentElement;
		let isOn = document.fullscreenElement !== null;

		// let on = !isOn;
		// if (on !== undefined && ((on && isOn) || (!on && !isOn))) return;
		console.log('---switch fullscreen:', isOn? 'off' : 'on', elem);

		if (isOn){
			await this.setFullscreen(false)

		}else{
			await this.setFullscreen(true, elem)
		}
	}
}